<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div class="col-md-10">
            <card-section-header
              title="Documents"
              icon="fas fa-list"
              buttonLabel="ADD DOCUMENT"
              buttonIcon="fas fa-plus"
              (buttonClick)="showUploadDocumentsModal()">
            </card-section-header>
            <div class="mb-2 animated fadeIn">
              <!-- Table of results -->
              <div class="row">
                <div class="col-md-12">
                  <p-table
                    [value]="siteDocuments"
                    [autoLayout]="true"
                    sortField="fileName"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th [pSortableColumn]="'fileName'">
                          Document
                          <p-sortIcon [field]="'fileName'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'createdDate'">
                          Uploaded on
                          <p-sortIcon [field]="'createdDate'"></p-sortIcon>
                        </th>
                        <th></th>
                        <th></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-document>
                      <tr [pSelectableRow]="document">
                        <td>{{document.fileName}}</td>
                        <td>{{document.createdDate | date: 'd MMM yyyy'}}</td>
                        <td><button type="button" class="btn btn-primary btn-link" (click)="viewDocument(document)">view</button></td>
                        <td><button type="button" class="btn btn-danger btn-link" (click)="deleteDocument(document)">delete</button></td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="2">
                          No documents found
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- add new document -->
<p-dialog header="Add Site Document" [(visible)]="isUploadDocumentsModalShown" modal="true" [baseZIndex]="1000000">

  <form *ngIf="!isLoading" (ngSubmit)="onUploadDocumentsFormSubmit()">
    <div class="form-group">
      <label for="chooseDocuments" class="btn btn-primary btn-round">Choose Documents</label>
      <input
        type="file"
        class="form-control"
        id="chooseDocuments"
        accept=".pdf, image/*, .doc, .docx, .ppt, .pptx, .pps, .ppsx, .odt, .xls, .xlsx, .key"
        (change)="onFileChange($event)"
        multiple
      />
      <ng-container *ngIf="selectedDocumentsArray.length">
        <p>Selected Files:</p>
        <ul>
          <li *ngFor="let file of selectedDocumentsArray">{{ file.name }}</li>
        </ul>
      </ng-container>
    </div>
  </form>
  <p-footer *ngIf="!isLoading">
    <button type="button" (click)="onUploadDocumentsFormSubmit()" [disabled]="!selectedDocumentsArray.length" class="btn btn-sm btn-success">Upload</button>
    <button type="button" (click)="isUploadDocumentsModalShown=false" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
  <div *ngIf="isLoading" style="width: 50%; margin: 0 auto">
    <p-progressSpinner></p-progressSpinner>
  </div>
</p-dialog>
